import myRequest from '@/services/myRequest';

const TRACK_EVENT_LIMIT = 200;
const TRACK_QUEUE_STORAGE_KEY = 'lvluo-button-click-log-queue';

let flushingButtonClickLogQueuePromise = null;

const readButtonClickLogQueue = () => {
  if (typeof localStorage === 'undefined') {
    return [];
  }

  try {
    const queue = JSON.parse(localStorage.getItem(TRACK_QUEUE_STORAGE_KEY) || '[]');
    return Array.isArray(queue) ? queue : [];
  } catch (error) {
    return [];
  }
};

const saveButtonClickLogQueue = (queue = []) => {
  if (typeof localStorage === 'undefined') {
    return;
  }

  localStorage.setItem(TRACK_QUEUE_STORAGE_KEY, JSON.stringify(queue.slice(-TRACK_EVENT_LIMIT)));
};

const pushButtonClickLogQueue = (payload) => {
  const nextQueue = [...readButtonClickLogQueue(), payload].slice(-TRACK_EVENT_LIMIT);
  saveButtonClickLogQueue(nextQueue);
};

// 查询所有平台
export async function queryPlatformList(params) {
  return myRequest('get', '/platform/queryPlatformList', params);
}

// 添加平台账号
export async function addAccountInfo(params) {
  return myRequest('post', '/platform/addAccountInfo', params, { requestType: 'json' });
}

// 查询平台账号
export async function queryAccountInfo() {
  return myRequest('get', '/platform/queryAccountInfo');
}

// 更新平台账号状态
export async function updateAccountInfoById(params) {
  return myRequest('post', '/platform/updateAccountInfoById', params, {
    requestType: 'json',
  });
}

// 进入账号中心日志
export async function enterUserCenterLog(params) {
  return myRequest('get', '/adminLog/enterUserCenter', params);
}

// 批量删稿日志
export async function removeArticleLog(params) {
  return myRequest('post', '/adminLog/removeArticleLog', params, {
    requestType: 'json',
  });
}

export async function buttonClickLog(params) {
  return myRequest('post', '/platform/buttonClickLog', params, {
    requestType: 'json',
  });
}

export async function flushButtonClickLogQueue() {
  if (flushingButtonClickLogQueuePromise) {
    return flushingButtonClickLogQueuePromise;
  }

  const queue = readButtonClickLogQueue();
  if (!queue.length) {
    return [];
  }

  flushingButtonClickLogQueuePromise = (async () => {
    const remainingQueue = [];

    for (let index = 0; index < queue.length; index += 1) {
      const payload = queue[index];
      try {
        const response = await buttonClickLog(payload);
        if (!response || response.code !== 0) {
          remainingQueue.push(payload);
        }
      } catch (error) {
        remainingQueue.push(payload);
      }
    }

    saveButtonClickLogQueue(remainingQueue);
    return remainingQueue;
  })();

  try {
    return await flushingButtonClickLogQueuePromise;
  } finally {
    flushingButtonClickLogQueuePromise = null;
  }
}

export async function reportButtonClickLog(payload) {
  try {
    const response = await buttonClickLog(payload);
    if (!response || response.code !== 0) {
      pushButtonClickLogQueue(payload);
      return;
    }
    await flushButtonClickLogQueue();
  } catch (error) {
    pushButtonClickLogQueue(payload);
  }
}

export async function queryButtonClickLog(params) {
  return myRequest('get', '/platform/queryButtonClickLog', params);
}

export async function getUserConfig(params) {
  return myRequest('get', '/user/getUserConfig', params);
}
